


























































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";
import moment from "moment";
import Item from "./item.vue"
import CKEditor from "@/components/ckeditor.vue";
import TsUpload from "@/components/upload.vue";

@Component({components:{
    Item,
    ckeditor: CKEditor,
    TsUpload,
    },
})
export default class extends Mixins(MyForm) {
  @Prop() data!: any;

  loading = false;

  interfaceType: string[] = ["ModBus", "RS485"];

  renderReportTime(time: string) {
    if (time == "0001-01-01T00:00:00Z") {
      return "";
    }

    return time;
  }

  async loadData1() {
    this.spinLoading = true;
    this.loading = true;

    const res = await this.$store.dispatch("investigate/info", {
      id: this.data.id
    });

    // console.log(res1);
    let switchEquipment: any = [];
    let content:any='';

    if (res && res.Data){
      if(typeof(res.Data)=='string') {
        content=res.Data;
      } else {
        switchEquipment = res.Data;
      }
    }
    // console.log(grounds)
    // console.log(mainEquipment);
    this.formData = {
      content:content,
      switchEquipment
    };

    this.loading = false;
    this.spinLoading = false;
  }

  async mounted() {
    console.log('data:',this.data)
    this.loadData1();
  }

  addSwitchItem() {
    const idx = this.formData.switchEquipment.length + 1;

    this.formData.switchEquipment.push({
      id: null,
      index: idx,
      title: ``,
      items: [{title:'',values:[{value:"",score:1},{value:"",score:2},{value:"",score:3},{value:"",score:4}]}]
    });
    console.log('item1:',this.formData.switchEquipment)
  }

  removeSwitchItem(index: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        this.formData.switchEquipment.splice(index,1);
        console.log('item2:',this.formData.switchEquipment,index)
      }
    });

    // 删除
  }

  // 添加规则配置项
  addControlRule(index: number) {
    this.formData.switchEquipment[index].items.push({
      title: "",
      values: [{value:"",score:1},{value:"",score:2},{value:"",score:3},{value:"",score:4}]
    });
    console.log('item3:',this.formData.switchEquipment,index)
  }

  // 移除规则配置项
  removeControlRule(index: number, key: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        console.log('item4:',this.formData.switchEquipment,index,key)
        this.formData.switchEquipment[index].items.splice(key,1);
      }
    });
  }

  async handleSubmit() {
    console.log('data:',this.data)
      if(this.data.mode==2){
        this.saveSubmit();
        return;
      }
      this.showTsConfirm({
        title: "确认信息",
        content: "你确定要提交吗？",
        onOk: async () => {
          this.confirmLoading = true;
          // 更新
          this.$store
            .dispatch("investigate/save", {
              id: this.data.id,
              title:this.data.title,
              mode:this.data.mode,
              content:JSON.stringify(this.formData.switchEquipment)
            })
            .then((res1: any) => {
              console.log(res1);
              // let switchEquipment: any = [];
              this.confirmLoading = false;
              if (res1 && res1.Code==200) {
                // 刷新一下数据
                this.loadData1();
                this.$message.success("保存成功");
                this.handleCancel();
              } else {
                this.$message.success("保存失败:"+(res1.Message ||''));
              }
            }).catch((err:any)=>{
              this.confirmLoading = false;
              this.$message.success("保存失败");
            });
        }
      });
  }

  async saveSubmit() {
      this.form.validateFields((err: any, values: any) => {
        console.log('form:',values)
        if(!err){
          this.showTsConfirm({
            title: "确认信息",
            content: "你确定要提交吗？",
            onOk: async () => {

              this.confirmLoading = true;

              // 更新
              this.$store
                .dispatch("investigate/save", {
                  id: this.data.id,
                  title:this.data.title,
                  mode:this.data.mode,
                  content:values.content,
                })
                .then((res1: any) => {
                  console.log(res1);
                  // let switchEquipment: any = [];
                  this.confirmLoading = false;
                  if (res1 && res1.Code==200) {
                    // 刷新一下数据
                    this.$message.success("保存成功");
                    this.handleCancel();
                  } else {
                    this.$message.success("保存失败:"+(res1.Message ||''));
                  }
                }).catch((err:any)=>{
                  this.confirmLoading = false;
                  this.$message.success("保存失败");
                });
            }
          });
        }
      })
  }

}
